import { Grid } from '@mui/material';
import CopyLengthSelect from '../CopyLengthSelect/CopyLengthSelect';
import AdditionalAdvertisersSelect from '../AdditionalAdvertisersSelect/AdditionalAdvertisersSelect';
import AdvertisersMultiselect from '../AdvertisersMultiselect/AdvertisersMultiselect';
import DeleteButton from './DeleteButton/DeleteButton';
import { Advertiser } from '../../interfaces';
import { Item } from '../../../../../../common/DefaultSelect/DefaultSelect';

interface NewCopyFormProps {
  index: number;
  totalRows: number;
  onRemove: () => void;
  onReset: (fieldName: string) => void;
  fetchedAdvertisers: Advertiser[];
  isAdvertisersFetching: boolean;
  fetchedCopyLengths: Item[];
  isCopyLengthsFetching: boolean;
}

export default function NewCopyForm({
  index,
  totalRows,
  onRemove,
  onReset,
  fetchedAdvertisers,
  isAdvertisersFetching,
  fetchedCopyLengths,
  isCopyLengthsFetching,
}: NewCopyFormProps) {
  return (
    <>
      <Grid item xs={3}>
        <CopyLengthSelect
          copyIndex={index}
          fetchedCopyLengths={fetchedCopyLengths}
          isCopyLengthsFetching={isCopyLengthsFetching}
        />
      </Grid>
      <Grid item xs={3}>
        <AdditionalAdvertisersSelect copyIndex={index} />
      </Grid>
      <Grid item xs={3}>
        <AdvertisersMultiselect
          copyIndex={index}
          fetchedAdvertisers={fetchedAdvertisers}
          isAdvertisersFetching={isAdvertisersFetching}
        />
      </Grid>
      <Grid item xs={3} display="flex" alignItems="center">
        <DeleteButton
          rowIndex={index}
          totalRows={totalRows}
          onRemove={onRemove}
          onReset={onReset}
        />
      </Grid>
    </>
  );
}
